import React from "react";
import { ReactComponent as LockIcon } from "components/Forms/form-icons/lock.svg";
import "./SafetyLock.css"; // Make sure the path is correct

const SafetyLock = (props) => {
  const showSafetyLock = props.dataSet?.showsafetylock ? props.dataSet.showsafetylock : 'disable';
  const safetyLockText = props.dataSet?.safetylocktext ? props.dataSet.safetylocktext : 'Safe, Secure and Confidential';

  if (showSafetyLock !== 'enable') return null;

  return (
    <div className="safety-lock">
      <LockIcon aria-hidden="true" />
      <span>{safetyLockText}</span>
    </div>
  );
};

export default SafetyLock;
